abstract class Render {
  public abstract render(object: any): JSX.Element | string | number | any;
}

export default Render;
